import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {common} from '@priority-software/priority-proto-api/lib';
import {getLang} from '../../../Localization';
import {getSelectedFieldsData, updateSelectedFieldsData} from '../../../services/serverStoreData';
import {
    getServerStoreData,
    setServerStoreData
} from '../../../services/proto/ServerStorage/service';
import {
    EditingFieldsType,
    SELECTED_VIEW_TYPE_STORE_KEY,
    ViewType,
    SHOW_TOTALS_FOR_ALL_STORE_KEY,
    MAP_SETTINGS_STORE_KEY,
    ROUTE_SHOW_TYPE_STORE_KEY
} from '../constants';
import {MapSettings} from '../types';
import {getKeyAndDefaultColsByType, getViewTypeOptions} from '../utils';
import {Dictionary} from '../../../features/EOYWizard/types';
import {Column} from '../../../stores/Form';

export const getSelectedFields = async (type: EditingFieldsType, FormName: string) => {
    const {storeKey, defaultCols} = getKeyAndDefaultColsByType(type);
    const key = `${storeKey}_${getLang()}_${FormName}`;
    return await getSelectedFieldsData(key, defaultCols);
};

export const updateSelectedFields = async (
    selectedFields: any[],
    formName: string,
    type: EditingFieldsType,
    shouldShowQuantitySelector: boolean
) => {
    const {storeKey} = getKeyAndDefaultColsByType(type);

    const key = `${storeKey}_${getLang()}_${formName}`;
    return await updateSelectedFieldsData(selectedFields, shouldShowQuantitySelector, key);
};

export const getViewTypeFromServer = async () => {
    const key = `${SELECTED_VIEW_TYPE_STORE_KEY}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);
    return res[key] ? {viewType: JSON.parse(res[key].Str)} : null;
};

export const getViewType = async (): Promise<DropdownItemData> => {
    const viewTypeInServer = await getViewTypeFromServer();
    const viewTypeOptions = getViewTypeOptions();
    const defaultView = viewTypeOptions[0];
    if (viewTypeInServer && viewTypeInServer.viewType) {
        const res = viewTypeOptions.find(item => item.value === viewTypeInServer.viewType);
        return res || defaultView;
    } else {
        return defaultView;
    }
};

export const updateViewType = async (viewType: ViewType) => {
    const key = `${SELECTED_VIEW_TYPE_STORE_KEY}_${getLang()}`;
    const viewToSave = new common.Constant({Str: JSON.stringify(viewType)});
    return setServerStoreData({[key]: viewToSave}, true, true);
};

const getColumnsWidthFromServer = async (storeKey: string) => {
    const key = `${storeKey}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);
    return res[key] ? {widthDictionary: JSON.parse(res[key].Str)} : null;
};
export const getColumnsWidthByKey = async (storeKey: string) => {
    const colsWidthInSerever = await getColumnsWidthFromServer(storeKey);
    if (colsWidthInSerever && colsWidthInSerever.widthDictionary) {
        return colsWidthInSerever.widthDictionary;
    } else {
        return {};
    }
};

export const updateColsWidthDictionaryInServer = async (storeKey, colsWidthDictionary) => {
    const key = `${storeKey}_${getLang()}`;
    const updatedValue = new common.Constant({Str: JSON.stringify(colsWidthDictionary)});
    return setServerStoreData({[key]: updatedValue}, true, true);
};

export const updateColsWidthDictionary = async (
    storeKey: string,
    colsWidthDictionary: Dictionary<number>,
    fields: string[],
    cols: Column[]
) => {
    const currentCols = cols.filter(col => fields.includes(col.Name));
    const updatedDictionary: Dictionary<number> = currentCols.reduce((acc, col) => {
        const colId = col.ID as number;
        acc[colId] = colsWidthDictionary[colId]
            ? colsWidthDictionary[colId]
            : col.defaultColumnWidth;
        return acc;
    }, {} as Dictionary<number>);
    await updateColsWidthDictionaryInServer(storeKey, updatedDictionary);
    return updatedDictionary;
};

export const getShowTotalsSettingsFromServer = async () => {
    const key = `${SHOW_TOTALS_FOR_ALL_STORE_KEY}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);
    return res[key] ? {showTotalsForAll: JSON.parse(res[key].Str)} : {showTotalsForAll: true};
};

export const updateShowTotalsForAll = async (showTotals: boolean) => {
    const key = `${SHOW_TOTALS_FOR_ALL_STORE_KEY}_${getLang()}`;
    const newSettings = new common.Constant({Str: JSON.stringify(showTotals)});
    return setServerStoreData({[key]: newSettings}, true, true);
};

export const getADPmapSettingsFromServer = async () => {
    const key = `${MAP_SETTINGS_STORE_KEY}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);
    return res[key] ? {mapSettings: JSON.parse(res[key].Str)} : null;
};

export const updateADPmapSettings = async (mpaSettings: MapSettings) => {
    const key = `${MAP_SETTINGS_STORE_KEY}_${getLang()}`;
    const newSettings = new common.Constant({Str: JSON.stringify(mpaSettings)});
    return setServerStoreData({[key]: newSettings}, true, true);
};

export const updateRouteShowType = async (showType: DropdownItemData[]) => {
    const key = `${ROUTE_SHOW_TYPE_STORE_KEY}_${getLang()}`;
    const newSettings = new common.Constant({Str: JSON.stringify(showType)});
    return setServerStoreData({[key]: newSettings}, true, true);
};

export const getRouteShowTypeFromServer = async () => {
    const key = `${ROUTE_SHOW_TYPE_STORE_KEY}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);
    return res[key] ? {showType: JSON.parse(res[key].Str)} : null;
};

export const getRouteShowType = async (): Promise<DropdownItemData[]> => {
    const showTypeInServer = await getRouteShowTypeFromServer();
    return showTypeInServer?.showType || [];
};
